exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ms-ContextualMenu-icon ._1KiZKEg8-nD4NulHDjAhzX{position:relative;top:-8px}", ""]);
// Exports
exports.locals = {
	"fallbackIcon": "_1KiZKEg8-nD4NulHDjAhzX"
};